import { 
    getRequestStudentsPendingStart, 
    getRequestStudentsPendingSuccess,
    getRequestStudentsPendingFailure,
    getRequestInvoicePendingSuccess,
} from "../reducers/analytics";

import axios from "../../api/axios";

export const getTotalRequestStudentsPending = (query) => async (dispatch) => {
    try {
        
        dispatch(getRequestStudentsPendingStart());

        // const response = await axios.get(`/analytics/totalRequestStudentPending?requestFrom=courses&requestStatus=pending`);
        const response = await axios.get(`/analytics/totalRequestPending?requestFrom=courses&requestStatus=${query}`);

        dispatch(getRequestStudentsPendingSuccess(response.data));

    } catch (error) {
        
        dispatch(getRequestStudentsPendingFailure());

    }
};
export const getTotalRequestInvoicePending = (query) => async (dispatch) => {
    try {
        
        dispatch(getRequestStudentsPendingStart());

        // const response = await axios.get(`/analytics/totalRequestStudentPending?requestFrom=courses&requestStatus=pending`);
        const response = await axios.get(`/analytics/totalRequestPending?requestFrom=invoice&requestStatus=${query}`);

        dispatch(getRequestInvoicePendingSuccess(response.data));

    } catch (error) {
        
        dispatch(getRequestStudentsPendingFailure());

    }
};

